/* @flow */
// https://gist.github.com/james2doyle/5694700
// easing functions http://goo.gl/5HLl8
function easeInOutQuad(t: number, b: number, c: number, d: number): number {
  let t1: number = t / (d / 2);
  if (t1 < 1) {
    return c / 2 * t1 * t1 + b;
  }
  let t2: number = t1 - 1;
  return -c / 2 * (t2 * (t2 - 2) - 1) + b;
}

function easeInCubic(t: number, b: number, c: number, d: number): number {
  let t1: number = t / d;
  let tc: number = t1 * t1 * t1;
  return b + c * tc;
}

function inOutQuintic(t: number, b: number, c: number, d: number): number {
  let t1: number = t / d;
  let ts: number = t1 * t1;
  let tc: number = ts * t1;
  return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
}

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
let requestAnimFrame = (() => (
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  function cb(callback) {
    window.setTimeout(callback, 1000 / 60);
  }
))();

export default function scrollTo(target: Object, to: number, duration: number, callback?: any) {
  function move(amount: number) {
    target.scrollTop = amount;
  }
  function position(target: Object): number {
    return target.scrollTop;
  }

  let duration1: number = (typeof(duration) === 'undefined') ? 500 : duration;
  let start: number = position(target);
  let change: number = to - start;
  let currentTime: number = 0;
  let increment: number = 20;

  function animateScroll() {
    // increment the time
    currentTime += increment;
    // find the value with the quadratic in-out easing function
    let val = easeInOutQuad(currentTime, start, change, duration);
    // move the document.body
    move(val);
    // do the animation unless its over
    if (currentTime < duration1) {
      requestAnimFrame(animateScroll);
    } else {
      if (callback && typeof(callback) === 'function') {
        // the animation is done so lets callback
        callback();
      }
    }
  }
  animateScroll();
}
